var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogSettings.dialog)?_c('ReasonForBookingDialog',{key:_vm.id,attrs:{"dialogSettings":_vm.dialogSettings,"reason-for-booking":_vm.reasonForBooking,"actionName":"Save Changes","loading":_vm.isLoading},on:{"close":_vm.close,"submit":_vm.handleEdit}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }